import { ChangeDetectionStrategy, Component, DestroyRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { AdditionalDocument } from '../../../core/models/freight-document/AdditionalDocument';
import { FreightDocument } from '../../../core/models/freight-document/FreightDocument';
import { FreightDocumentService } from '../../../core/services/freight-document.service';
import { ErrorMessage } from '../../../core/models/ErrorMessage';

@Component({
  selector: 'app-share-pdf-modal',
  template: `
      <app-modal>
          <ng-container class="title">
              {{ 'action.sharePdf' | transloco | uppercase }}
          </ng-container>
          <ng-container class="actions">
              <button type="button" class="button-secondary" aria-label="Close" (click)="activeModal.dismiss()">
                  {{ 'action.close' | transloco | uppercase }}
              </button>
          </ng-container>

          <ng-container class="content">
              <app-errors [errors]="errors$ | async"></app-errors>
              <app-document-share [options]="options" (download)="onDownload($event)"></app-document-share>
          </ng-container>
      </app-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharePdfModalComponent {
  @Input({ required: true }) fd: FreightDocument;
  @Input({ required: true }) options: AdditionalDocument[];

  protected errors$ = new Subject<ErrorMessage[]>();

  constructor(public activeModal: NgbActiveModal,
              private freightDocumentService: FreightDocumentService,
              private destroyRef: DestroyRef) {
  }

  onDownload(option: AdditionalDocument): void {
    this.freightDocumentService.saveAdditionalDocument(this.fd, option, SharePdfModalComponent.name)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({ error: (errors: ErrorMessage[]) => this.errors$.next(errors) });
  }
}
